module.exports = __webpack_public_path__ + "static/media/module1b-male.ee45d61.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/module1b-male.mp4
// module id = A4JE
// module chunks = 0